import { render, staticRenderFns } from "./ToggleTemplate.vue?vue&type=template&id=c06fa7b2"
import script from "./ToggleTemplate.vue?vue&type=script&lang=js"
export * from "./ToggleTemplate.vue?vue&type=script&lang=js"
import style0 from "./ToggleTemplate.vue?vue&type=style&index=0&id=c06fa7b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports